export enum BuildRuntimePlatform {
  DARWIN = 'darwin',
  LINUX = 'linux',
}
